import APIService from '../api.service';

export const List = (params) => {
  return APIService.get(`/v01/consumption-items`, {
    params: {
      per_page: params.perPage,
      page: params.page,
      keyword: params.keyword,
      consumption_no: params.consumptionNo,
      start_date: params.startDate,
      end_date: params.endDate,
      status: params.status,
      consumption_type_id: params.consumption_type_id,
    },
  });
};

const ConsumptionItemService = {
  List,
};

export default ConsumptionItemService;
